<script lang="ts">
  import { Tag } from "@opera-gx/components";
  export let tag = false;
  export let tagColor = "";
  export let tagText = "";
</script>

<style lang="postcss">
  .wrapper {
    @apply relative;
  }

  .tile {
    min-height: 100%;
    min-width: 100%;
    mask-border-source: url("./background.svg");
    mask-border-slice: 20 fill;
    mask-border-width: var(--borderWidth);
  }

  .tag {
    position: absolute;
    top: -10px;
    right: -19px;
    z-index: -1;
  }

  .tile::after {
    @apply pointer-events-none;
    @apply absolute;
    @apply inset-0;
    @apply z-10;

    content: "";
    mask-border-source: url("./border-2px.svg");
    mask-border-slice: 20 fill;
    mask-border-width: var(--borderWidth);
  }
</style>

<div class="{$$props.class} wrapper">
  <div class="flex items-center justify-between" style="height: var(--height);">
    <slot class="tile" />
  </div>
  {#if tag}
    <div class="tag">
      <Tag color={tagColor}>{tagText}</Tag>
    </div>
  {/if}
</div>
